import Button from '../../../../components/designSystem/Button/Button';
import { ButtonColor } from '../../../../components/designSystem/Button/Button.types';
import ouvrier from '../../../../assets/images/ouvrier_poncage_accueil.jpg';
import carreleur from '../../../../assets/images/carreleur_accueil.jpg';
import { PLACEHOLDERS_QUERY_KEY } from '../../../../hooks/fetchers/usePlaceholders/usePlaceholders';
import { useEffect, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Placeholders } from '../../../../types/models/placeholders/placeholders.types';
import { placeholdersQuery } from '../../../../hooks/fetchers/usePlaceholders/usePlaceholders.query';

export default () => {
  const queryClient = useQueryClient();

  const [description, setDescription] = useState('');

  // const { data: placeholders, status } = usePlaceholders(['home_news'])

  const { mutate } = useMutation<Awaited<Placeholders[]>, Error, string[]>(
    (data) => placeholdersQuery(data),
    {
      mutationKey: PLACEHOLDERS_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: (response) => {
        setDescription(
          response?.find((placeholder) => placeholder.name === 'home_news')?.value || ''
        );
      },
      // onError: (error) => {
      //   alert(error.message);
      // },
    }
  );

  useEffect(() => mutate(['home_news']), []);

  // const description = useMemo(
  //   () => placeholders?.find(placeholder => placeholder.name === 'home_news')?.value,
  //   [placeholders, isLoading, isFetching]
  // )

  // useEffect(() => {
  //   setDescription(placeholders?.find(placeholder => placeholder.name === 'home_news')?.value || 't')
  // }, [placeholders, status])

  return (
    <div className="home__newsLayer">
      <div className="home__newsLayerImagesBox">
        <img className="home__newsLayerImage home__newsLayerImage--large" src={ouvrier} />
        <img className="home__newsLayerImage home__newsLayerImage--small" src={carreleur} />
      </div>
      <div className="home__newsLayerBox">
        <span className="font-regular font-size-medium text-white">NEWS</span>
        <span className="font-bold font-size-large text-white">
          PRÉSENTATION DE LA PLATEFORME AUX ACHETEURS PUBLICS
        </span>
        <span className="font-regular font-size-small text-white">{description}</span>
        <a href="/register/PUB">
          <Button color={ButtonColor.Contrast}>Je participe !</Button>
        </a>
      </div>
    </div>
  );
};
